import { z } from "zod";
export const Standard5PageIdSchema = z.enum([
    "home",
    "about",
    "services",
    "service-areas",
    "contact",
]);
export const Standard5ContentRequirementV1Schema = z
    .object({
    pageId: Standard5PageIdSchema,
    requiredSections: z.array(z.string().min(1)),
    minWordCount: z.number().int().min(0).default(0),
    requiresProof: z.boolean().default(false),
})
    .strict();
export const Standard5PageRequirementV1Schema = z
    .object({
    schemaVersion: z.literal("standard5-page-requirement.v1.0"),
    pages: z.array(Standard5ContentRequirementV1Schema),
    forbiddenRoutes: z
        .array(z.string())
        .default(["/services/*", "/city/*", "/locations/*"]),
})
    .strict();
export const Standard5FallbackV1Schema = z
    .object({
    schemaVersion: z.literal("standard5-fallback.v1.0"),
    pageId: Standard5PageIdSchema,
    fallbackReason: z.string().min(1),
    safePlaceholderAllowed: z.boolean().default(false),
})
    .strict();
export const STANDARD5_PAGE_REQUIREMENTS = Standard5PageRequirementV1Schema.parse({
    schemaVersion: "standard5-page-requirement.v1.0",
    pages: [
        { pageId: "home", requiredSections: ["hero", "services", "contact"], minWordCount: 50 },
        { pageId: "about", requiredSections: ["about"], minWordCount: 40 },
        { pageId: "services", requiredSections: ["services"], minWordCount: 40, requiresProof: false },
        { pageId: "service-areas", requiredSections: ["service-areas"], minWordCount: 30 },
        { pageId: "contact", requiredSections: ["contact"], minWordCount: 20 },
    ],
    forbiddenRoutes: ["/services/*", "/city/*", "/locations/*"],
});
//# sourceMappingURL=standard5.js.map